import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { hooks } from '../hooks';
import { components } from '../components';

export const MyWishlist: React.FC = () => {
  const { pathname } = useLocation();

  // State to manage input fields
  const [rentAmount, setRentAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title="Pay Rent"
        goBack={true}
      />
    );
  };

  const handleRentAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRentAmount(e.target.value);
  };

  const handlePaymentMethodChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPaymentMethod(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Rent Amount:', rentAmount);
    console.log('Payment Method:', paymentMethod);
    // Add further actions here, like API calls or navigation.
  };

  const renderContent = (): JSX.Element => {
    return (
      <main style={{ paddingBottom: 0 }}>
        {/* Rent Payment Form */}
        <div style={{ marginTop: 20, padding: '0 20px' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 15 }}>
              <label htmlFor="rentAmount" style={{ display: 'block', fontWeight: 'bold', marginBottom: 10 }}>
                Rent Amount
              </label>
              <input
                id="rentAmount"
                type="text"
                value={rentAmount}
                onChange={handleRentAmountChange}
                placeholder="Enter rent amount"
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: 5,
                  border: '1px solid #ccc',
                }}
              />
            </div>

            <div style={{ marginBottom: 15 }}>
              <label htmlFor="paymentMethod" style={{ display: 'block', fontWeight: 'bold', marginBottom: 10 }}>
                Payment Method
              </label>
              <input
                id="paymentMethod"
                type="text"
                value={paymentMethod}
                onChange={handlePaymentMethodChange}
                placeholder="Enter payment method"
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: 5,
                  border: '1px solid #ccc',
                }}
              />
            </div>

            {/* Submit Button */}
            <components.Button
              title="Pay Now"
              style={{
                backgroundColor: '#7065F0',
                color: '#fff',
                border: '1px solid #7065F0',
                width: '100%',
                padding: '12px',
                borderRadius: 5,
              }}
            />
          </form>
        </div>
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
